import { computed, ComputedRef, inject, provide } from "vue";
import { AdTemplatePreroll } from "@fresh8/types/src";
import { BackgroundImageSetMap } from "@fresh8/types/src";
import useBackgroundImage from "./useBackgroundImage";

export function usePreroll(
  brandPreroll: ComputedRef<AdTemplatePreroll>,
  sizeId: ComputedRef<string>,
  prerollImageSet: ComputedRef<BackgroundImageSetMap>
): {
  prerollTargetUrl: ComputedRef<string | undefined>;
  usePreroll: ComputedRef<boolean>;
  prerollImage: ComputedRef<string | undefined>;
  prerollName: ComputedRef<string | undefined>;
} {
  const prerollImageData = useBackgroundImage(
    sizeId,
    "preroll",
    prerollImageSet
  );

  const usePreroll = computed(
    () =>
      !!brandPreroll.value?.usePreroll &&
      !!prerollImageData.value.backgroundImage
  );

  return {
    prerollTargetUrl: computed(() => brandPreroll.value?.prerollTargetUrl),
    usePreroll,
    prerollImage: computed(() => prerollImageData.value.backgroundImage),
    prerollName: computed(() => prerollImageData.value.backgroundImageSetName)
  };
}

export type PrerollContext = ReturnType<typeof usePreroll>;
export const brandSymbol = Symbol("prerollSymbol");

export function providePreroll(
  brandPreroll: ComputedRef<AdTemplatePreroll>,
  sizeId: ComputedRef<string>,
  prerollImageSet: ComputedRef<BackgroundImageSetMap>
): void {
  provide(brandSymbol, usePreroll(brandPreroll, sizeId, prerollImageSet));
}

export function injectPreroll(): PrerollContext | undefined {
  return inject<PrerollContext>(brandSymbol);
}
